import './App.css';
import Navbar from './components/Navbar/Navbar';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Footer from './components/Footer/Footer';
import { AuthProvider } from './components/Navbar/AuthContext';
import LandingPage from './components/landingpage/LandingPage';
import { AllCreators } from './components/landingpage/AllCreators';
import SignIn from './components/signin/SignIn';
import SignUp from './components/signup/SignUp';
import Forgot from './components/signin/ForgotPassword/Forgot';
import AllExams from './components/landingpage/AllExams';
import TestSeriesFilter from './components/landingpage/TestSeriesFilter';
import SubjectWiseTestFilter from './components/landingpage/SubjectWiseTestFilter';
import ExamTearmsAndConditions from './components/liveexam/ExamTearmsAndConditions';
import LiveExam from './components/liveexam/LiveExam';
import ExamResult from './components/liveexam/ExamResult';
import TestResults from './components/student/TestResults';
import MySubcriptions from './components/student/MySubscriptions';
import CreateTest from './components/creator/CreateTest';
import MyCreatedTest from './components/creator/MyCreatedTest';
// import EditTest from './components/teacher/EditTest';
import ViewTest from './components/creator/ViewTest';
import CreatorProfile from './components/UserProfile/CreatorProfile';
import StudentProfile from './components/UserProfile/StudentProfile';
import ScrollToTop from './components/common/ScrollToTop';
import ProtectedRoute from './components/common/ProtectedRoute';
import AuthRedirect from './components/common/AuthRedirect';
import CreatorNotAccessDashboard from './components/creator/CreatorNotAccessDashboard';
import NotFound from './components/common/NotFound';
import AboutUs from './components/common/AboutUs';
import TermsAndConditions from './components/common/TermsAndConditions';
import ContactUs from './components/common/ContactUs';
import TestDetailsPage from './components/liveexam/TestDetailsPage';
import EditTest from './components/creator/EditTest';
import GoogleAuthCallback from './components/signup/GoogleAuthCallback';
import ExcelExamUpload from './components/creator/ExcelExamUpload';
import Exams from './components/landingpage/Exams';
import ExamDetails from './components/landingpage/ExamDetails';
import { HelmetProvider } from 'react-helmet-async';
import SEO from './components/common/SEO';

function App() {
  return (
    <Router>
      <HelmetProvider>
        <SEO />
        <ScrollToTop>
          <AuthProvider>


            <Navbar />
            <Routes>
              {/* Public routes */}
              <Route exact path='/' element={<LandingPage />} />
              <Route exact path='/allcreators' element={<AllCreators />} />
              <Route exact path='/alltest' element={<AllExams />} />
              <Route exact path="/testseries/:series" element={<TestSeriesFilter />} />
              <Route exact path="/subject-wise-series/:series" element={<SubjectWiseTestFilter />} />
              <Route exact path='/aboutus' element={<AboutUs />} />
              <Route exact path='/terms-and-conditions' element={<TermsAndConditions />} />
              <Route exact path='/contactus' element={<ContactUs />} />
              <Route path="/test/:testName/:testId" element={<TestDetailsPage />} />
              <Route path="/exams-details" element={<Exams />} />
              <Route path="/exams-details/:examSlug" element={<ExamDetails />} />

              {/* Auth routes - only accessible when NOT logged in */}
              <Route element={<AuthRedirect />}>
                <Route exact path='/signin' element={<SignIn />} />
                <Route exact path='/signup' element={<SignUp />} />
                <Route exact path='/forgotpassword' element={<Forgot />} />
                <Route path="/auth/success" element={<GoogleAuthCallback />} />
              </Route>

              {/* Protected student routes */}
              <Route element={<ProtectedRoute allowedRoles={['student']} restrictedRoles={['creator']} />}>
                <Route exact path='/student-profile' element={<StudentProfile />} />
                <Route exact path='/exam-terms-conditions' element={<ExamTearmsAndConditions />} />
                <Route exact path='/live-exam' element={<LiveExam />} />
                <Route exact path="/my-performance" element={<TestResults />} />
                <Route exact path='/exam-result' element={<ExamResult />} />
                <Route exact path='/my-subcriptions' element={<MySubcriptions />} />
              </Route>


              {/* Protected creator routes */}
              <Route element={<ProtectedRoute allowedRoles={['creator']} restrictedRoles={['student']} />}>
                <Route exact path='/create-test' element={<CreateTest />} />
                <Route exact path='/creator-profile' element={<CreatorProfile />} />
                <Route exact path='/my-created-test' element={<MyCreatedTest />} />
                <Route exact path="/view-test/:id" element={<ViewTest />} />
                <Route exact path="/creator-restricted-dashboard" element={<CreatorNotAccessDashboard />} />
                <Route exact path="/edit-test/:testId" element={<EditTest />} />
                <Route exact path="/create-test-with-excel" element={<ExcelExamUpload />} />

              </Route>

              <Route path="*" element={<NotFound />} />
            </Routes>
            <Footer />
          </AuthProvider>
        </ScrollToTop>
      </HelmetProvider>
    </Router>

  );
}

export default App;
